import { LocalDate } from '@js-joda/core';
import { useMemo } from 'react';

import { VisitView } from '@dreryk/egabinet-dashboard-frontend-api';

import { Text } from '@dreryk/react-components';

import { StyledConfirmedAppointmentsCardCount } from './ConfirmedAppointmentsCardCount.styled';

type ConfirmedAppointmentsCardCountProps = {
   readonly visitsView: VisitView[];
};

export const ConfirmedAppointmentsCardCount = (props: ConfirmedAppointmentsCardCountProps): JSX.Element => {
   const todaysVisit = useMemo(() => {
      const today = LocalDate.now();
      return props.visitsView.find((visit) => visit.visitDate.equals(today));
   }, [props.visitsView]);

   return (
      <Text testId={'confirmedAppointmentsCount'}>
         <StyledConfirmedAppointmentsCardCount>
            {todaysVisit?.finishedApprovedCount ?? 0}
         </StyledConfirmedAppointmentsCardCount>
      </Text>
   );
};
